
import { windownLoad } from './utils/Events';

import './utils/ScrollTo';
import { stickHeaderInit } from './utils/StickyHeader';


import './Validation';
import { startAOS } from './effects/AnimationOnScroll';
// import MatchHeight from 'matchheight';
import './swipers';



// datepicker
import { Datepicker } from 'vanillajs-datepicker';
import dayjs from 'dayjs';


$('html').removeClass('no-js');

function _calculateScrollbarWidth() {
	document.documentElement.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
}
// recalculate on resize
window.addEventListener("resize", _calculateScrollbarWidth, false);
// recalculate on dom load
document.addEventListener("DOMContentLoaded", _calculateScrollbarWidth, false);
// recalculate on load (assets loaded as well)
window.addEventListener("load", _calculateScrollbarWidth);

stickHeaderInit({
    header:'.main-header'
});



windownLoad(() =>{

    startAOS();

});




// paralax background
